<div class="col-12 min-h-100 bg-container d-flex flex-column">
    
    <div class="col-12 flex-grow-1 bg-blur d-flex justify-content-center">

        <div class="content-container d-flex flex-column align-items-center shadow-large p-1 p-sm-2 p-md-3 p-lg-4 p-xl-5 justify-content-center position-relative">
        
            <ng-content/>
            
        </div>

    </div>

</div>